(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-image-slider"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".club-noe-section").forEach(function (sectionEl) {
    function ensureSwiperReady(callback) {
      if (typeof Swiper !== 'undefined') {
        callback();
        return;
      }

      if (typeof window.__amLoadSwiper === 'function') {
        window.__amLoadSwiper()
          .then(function () { callback(); })
          .catch(function () {});
        return;
      }

      setTimeout(function () { ensureSwiperReady(callback); }, 120);
    }

    const run = function () {
      const swiperInstances = {};

      function createSwiper(el, id, reverse = false, slidesPerView = 3.5) {
        if (!el) return;
        if (el.dataset.swiperInited) return;
        if (typeof Swiper === 'undefined') return;

        const slideCount = el.querySelectorAll(".swiper-slide").length;
        const loopEnabled = slideCount > Math.ceil(slidesPerView);

        if (swiperInstances[id]) {
          swiperInstances[id].destroy(true, true);
          delete swiperInstances[id];
        }

        el.dataset.swiperInited = "1";
        const swiper = new Swiper(el, {
          slidesPerView: slidesPerView,
          spaceBetween: 16,
          loop: loopEnabled,
          speed: 10000,
          autoHeight: false,
          observer: false,
          observeParents: false,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: reverse,
          },
          allowTouchMove: true,
          grabCursor: true,
          simulateTouch: true,
          freeMode: true,
          freeModeMomentum: false,
          centeredSlides: false,
          breakpoints: {
            320: { slidesPerView: 2.2 },
            480: { slidesPerView: 2.2 },
            768: { slidesPerView: 2.5 },
            1024: { slidesPerView: slidesPerView },
          },
        });

        swiperInstances[id] = swiper;

        el.addEventListener("mouseenter", () => { if (swiper.autoplay?.stop) swiper.autoplay.stop(); });
        el.addEventListener("mouseleave", () => { if (swiper.autoplay?.start) swiper.autoplay.start(); });
      }

      const tabButtons = sectionEl.querySelectorAll(".tab-button");
      const tabContents = sectionEl.querySelectorAll(".tab-content");

      tabButtons.forEach((btn, index) => {
        btn.addEventListener("click", function () {
          tabButtons.forEach((b) => b.classList.remove("active"));
          this.classList.add("active");
          tabContents.forEach((content) => content.classList.remove("active"));
          const activeTab = sectionEl.querySelector(`#${this.dataset.tab}`);
          if (!activeTab) return;
          activeTab.classList.add("active");

          const leftSwiperEl = activeTab.querySelector(".left-to-right");
          const rightSwiperEl = activeTab.querySelector(".right-to-left");
          const sid = sectionEl.dataset.sectionId || "club-noe";
          createSwiper(leftSwiperEl, `left-${sid}-${index}`, false, 3.5);
          createSwiper(rightSwiperEl, `right-${sid}-${index}`, true, 3.5);
        });
        if (index === 0) btn.click();
      });
    };

    const io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      ensureSwiperReady(function () {
        if (typeof requestIdleCallback !== 'undefined') requestIdleCallback(run, { timeout: 2500 });
        else setTimeout(run, 100);
      });
    }, { rootMargin: '300px' });
    io.observe(sectionEl);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-multibrands-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".am-multibrands-slider").forEach(function (sectionEl) {
  function whenSwiperReady(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
      return;
    }

    if (typeof window.__amLoadSwiper === "function") {
      window.__amLoadSwiper()
        .then(function () {
          callback();
        })
        .catch(function () {});
      return;
    }

    let attempts = 0;
    const maxAttempts = 20;
    const poller = setInterval(function () {
      if (typeof Swiper !== "undefined") {
        clearInterval(poller);
        callback();
        return;
      }
      attempts += 1;
      if (attempts >= maxAttempts) {
        clearInterval(poller);
      }
    }, 150);
  }

  const run = function () {
    const swiperInstances = {};
    let pendingTabButton = null;

    function createSwiper(el, id, reverse = false) {
      if (!el) return;
      const wrapper = el.querySelector(".swiper-wrapper");
      if (!wrapper) return;
      const slides = wrapper.querySelectorAll(".swiper-slide");
      if (slides.length === 0) return;
      if (typeof Swiper === "undefined") return;

      if (swiperInstances[id]) {
        swiperInstances[id].destroy(true, true);
        delete swiperInstances[id];
      }
      if (el.dataset.swiperInited) return;
      el.dataset.swiperInited = "1";

      const originalSlides = Array.from(slides);
      for (let i = 0; i < 3; i++) {
        originalSlides.forEach(slide => {
          wrapper.appendChild(slide.cloneNode(true));
        });
      }

      try {
        const section = el.closest(".am-multibrands-slider");
        const swipeSpeed = section && section.dataset.swipeSpeed ? parseInt(section.dataset.swipeSpeed, 10) : 3000;
        const swipeDelay = section && section.dataset.swipeDelay ? parseInt(section.dataset.swipeDelay, 10) : 3000;

        const swiper = new Swiper(el, {
          slidesPerView: "auto",
          spaceBetween: 8,
          breakpoints: { 0: { spaceBetween: 4 }, 751: { spaceBetween: 8 } },
          loop: true,
          loopAdditionalSlides: 8,
          speed: swipeSpeed,
          autoHeight: false,
          observer: false,
          observeParents: false,
          freeMode: true,
          freeModeMomentum: false,
          allowTouchMove: true,
          grabCursor: true,
          simulateTouch: true,
          autoplay: { delay: swipeDelay, disableOnInteraction: false, reverseDirection: reverse },
        });

        el.addEventListener("mouseenter", function () { if (swiper.autoplay && swiper.autoplay.stop) swiper.autoplay.stop(); });
        el.addEventListener("mouseleave", function () { if (swiper.autoplay && swiper.autoplay.start) swiper.autoplay.start(); });
        swiperInstances[id] = swiper;
      } catch (error) {
        el.dataset.swiperInited = "";
        console.error("AM Multibrands Slider: Error initializing slider", id, error);
      }
    }

    const tabButtons = sectionEl.querySelectorAll(".tab-button");
    const tabContents = sectionEl.querySelectorAll(".tab-content");

    tabButtons.forEach((btn, index) => {
      btn.addEventListener("click", function () {
        pendingTabButton = this;
        tabButtons.forEach((b) => b.classList.remove("active"));
        this.classList.add("active");
        tabContents.forEach((content) => content.classList.remove("active"));
        const activeTab = sectionEl.querySelector(`#${this.dataset.tab}`);
        if (activeTab) {
          activeTab.classList.add("active");
          const sid = sectionEl.dataset.sectionId || "mb";
          const leftSwiperEl = activeTab.querySelector(".swiper:not(.swiper-reverse)");
          const rightSwiperEl = activeTab.querySelector(".swiper.swiper-reverse");
          whenSwiperReady(function () {
            if (pendingTabButton !== btn) return;
            createSwiper(leftSwiperEl, `left-${sid}-${index}`, false);
            createSwiper(rightSwiperEl, `right-${sid}-${index}`, true);
          });
        }
      });
      if (index === 0) btn.click();
    });
  };

  const io = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) return;
    io.disconnect();
    whenSwiperReady(function () {
      if (typeof requestIdleCallback !== 'undefined') requestIdleCallback(run, { timeout: 2500 });
      else setTimeout(run, 100);
    });
  }, { rootMargin: '300px' });
  io.observe(sectionEl);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
